export default __webpack_public_path__ + "static/media/Shohoz-sebha .f9b7cc64.png";